(function() {
  var init = function() {
  RamblerShare.init('.rambler-share', {
    "style": {
      "iconSize": 16,
      "borderRadius": 30,
      "tooltipBorderRadius": 1,
      "tooltipFontSize": 10,
      "tooltipFontWeight": 300,
      "tooltipBoxShadowColor": "#fff",
      "tooltipBoxShadowOffsetY": 0,
      "tooltipBackground": "#343b4c",
      "tooltipColor": "#fff"
    },
    "utm": "utm_medium=social",
    "counters": false,
    "buttons": [
      "vkontakte",
      "odnoklassniki",
      "moimir",
      "telegram",
      "viber",
      "whatsapp",
      "email",
      "copy"
    ]
  });
};
var script = document.createElement('script');
script.onload = init;
script.async = true;
script.src = 'https://developers.rambler.ru/likes/v1/widget.js';
  document.head.appendChild(script);
})();
